// Clean Modular Custom JS Scripts
// Avoid polluting the global namespace
window.ShopifyCustom = window.ShopifyCustom || {};

ShopifyCustom.init = function () {
    this.runSafe("visualNavRouter", this.visualNavRouter);
    this.runSafe("setupScrollObservers", this.setupScrollObservers);
    this.runSafe("updateConstructorStickyAttributes", this.updateConstructorStickyAttributes);
    this.runSafe("handleWaitlistButtonVisibility", this.handleWaitlistButtonVisibility);
    this.runSafe("setVariantOnLoad", this.setVariantOnLoad);
    //this.runSafe("removeBodyInlineStyles", this.removeBodyInlineStyles);
    //this.runSafe("removeHtmlInlineHtmlStyles", this.removeHtmlInlineHtmlStyles);
};

ShopifyCustom.runSafe = function (name, fn) {
    try {
        fn();
        console.info(`✅ Test Passed: [custom.js] Executed ${name} successfully`);
    } catch (err) {
        console.warn(`‼️ Test Failed: [custom.js] Failed ${name}:`, err);
    }
};


ShopifyCustom.visualNavRouter = function () {
    const nav = document.querySelector('.js-router-enabled');
    const component = document.querySelector('.react-plp-grid');
    if (!nav || !component) return;
  
    // Flag to avoid false-positive popstate on page load
    let didPushState = false;
  
    nav.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link || !nav.contains(link)) return;
  
      e.preventDefault();
  
      nav.querySelectorAll('a.isActive').forEach((activeLink) => {
        if (activeLink !== link) {
          activeLink.classList.remove('isActive');
        }
      });
  
      link.classList.add('isActive');
  
      const newUrl = new URL(link.getAttribute('href'), window.location.origin);
      const fullPath = newUrl.pathname;
  
      // Push state
      history.pushState({}, '', fullPath);
      didPushState = true;
  
      // Trigger re-render in React
      const currentVal = parseInt(component.getAttribute('data-increment')) || 0;
      component.setAttribute('data-increment', currentVal + 1);
    });
  
    // Handle back/forward
    window.addEventListener('popstate', function () {
      // Only trigger reload on user navigation (not page load)
      if (didPushState) {
        window.location.reload();
      } else {
        // This is the first popstate (possibly on load), ignore and flip flag
        didPushState = true;
      }
    });
  };  


ShopifyCustom.setupScrollObservers = function () {
    const targets = document.querySelectorAll('.js-scroll-observer');

    if (!targets.length) return;

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
            const el = entry.target;
            if (
                entry.isIntersecting &&
                entry.intersectionRatio >= 0.5 &&
                entry.boundingClientRect.top > 0 // ensures it's scrolling *down* into view
            ) {
                el.classList.add('observerIsVisible');
                observerInstance.unobserve(el); // stop observing once it's visible
            }
        });
    }, {
        threshold: 0.5 // trigger when 50% of the element is in view
    });
    targets.forEach(el => observer.observe(el));
}

ShopifyCustom.removeHtmlInlineHtmlStyles = function () {
  const htmlEl = document.documentElement;
  if (!htmlEl) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        const newValue = htmlEl.getAttribute('style');
        console.log('[MutationObserver] <html> style changed:', newValue);

        requestAnimationFrame(() => {
          const currentStyle = htmlEl.getAttribute('style');
          if (!currentStyle) {
            console.log('[Cleaner] No inline style to clean.');
            return;
          }

          const cleanedRules = [];
          const removedProps = [];

          currentStyle
            .split(';')
            .map(rule => rule.trim())
            .forEach(rule => {
              if (!rule) return;
              const [prop] = rule.split(':');
              if (['overflow', 'inset', 'position'].includes(prop?.trim().toLowerCase())) {
                removedProps.push(prop.trim());
              } else {
                cleanedRules.push(rule);
              }
            });

          if (removedProps.length > 0) {
            if (cleanedRules.length > 0) {
              htmlEl.setAttribute('style', cleanedRules.join('; ') + ';');
            } else {
              htmlEl.removeAttribute('style');
            }

            console.log(`[Cleaner] Removed from <html> style: ${removedProps.join(', ')}`);
            console.log('[Cleaner] Remaining styles:', cleanedRules.join('; '));
          } else {
            console.log('[Cleaner] No matching styles to remove.');
          }
        });
      }
    }
  });

  observer.observe(htmlEl, {
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['style'],
  });

  console.log('[Observer] Started watching <html> for inline style changes.');
};


ShopifyCustom.removeBodyInlineStyles = function () {
  const bodyEl = document.body;
  if (!bodyEl) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        setTimeout(() => {
          console.log('Removing inline styles from body');
          bodyEl.removeAttribute('style');
        }, 10);
      }
    }
  });

  observer.observe(bodyEl, {
    attributes: true,
    attributeFilter: ['style'],
  });
};

ShopifyCustom.updateConstructorStickyAttributes = function () {
  const stickyEl = document.getElementById('constructor-product-info');
  if (!stickyEl) return;

  document.addEventListener('variant:change', function (event) {

      console.log('variant:change event triggered');
      const variant = event.detail?.variant;
      if (!variant) return;

      stickyEl.setAttribute('data-cnstrc-item-variation-id', variant.id);
      stickyEl.setAttribute('data-cnstrc-item-price', (variant.price / 100).toFixed(2));
  });
};

ShopifyCustom.handleWaitlistButtonVisibility = function () {
  // Helper function to update button visibility
  function updateButtonState(variant) {
    console.log("Updating button state for variant:", variant);

    // Skip if this is a product with grouping (they handle their own waitlist logic)
    const productGrouping = document.querySelector("product-grouping");
    if (productGrouping) return;

    // Find the product form and buttons
    const addToCartForm = document.querySelector(
      ".product-info .shopify-product-form"
    );
    if (!addToCartForm) return;

    const addToCartButton = addToCartForm.querySelector(
      'buy-buttons button[type="submit"]'
    );
    const notifyMeBtn = addToCartForm.querySelector(
      "buy-buttons button[data-bis-trigger]"
    );
    const addToCartButtonText = addToCartButton?.querySelector("div");
    const soldOutElement = document.querySelector(
      ".product-info sold-out-badge"
    );

    if (!addToCartButton || !notifyMeBtn || !addToCartButtonText) return;

    if (variant.available) {
      // Variant is available - show add to cart, hide waitlist
      const isPreorder = document
        .querySelector("#main-product-info")
        ?.classList.contains("preorder");

      if (addToCartButton) {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("button--subdued");
        addToCartButton.style.display = "block";
      }

      // Update button text with price
      const formattedPrice = (variant.price / 100).toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
      });

      if (addToCartButtonText) {
        addToCartButtonText.textContent = isPreorder
          ? "PREORDER"
          : `Add to Bag`;
      }

      if (notifyMeBtn) notifyMeBtn.style.display = "none";
      if (soldOutElement) soldOutElement.classList.add("is-hidden");
    } else {
      // Variant is sold out - show waitlist, hide add to cart
      if (addToCartButton) {
        addToCartButton.style.display = "none";
      }
      if (addToCartButtonText) {
        addToCartButtonText.textContent = "Sold Out";
      }
      if (notifyMeBtn) {
        notifyMeBtn.style.display = "block";
      }
      if (soldOutElement) {
        soldOutElement.classList.remove("is-hidden");
      }
    }
  }

  // Listen for variant changes
  document.addEventListener("variant:change", function (event) {
    console.log("Handling waitlist button visibility for variant change");
    const variant = event.detail?.variant;
    if (!variant) return;

    updateButtonState(variant);

    // Notify AMP Back in Stock app about variant change
    notifyAmpBackInStock(variant);
  });

  // Function to notify AMP Back in Stock app about variant changes
  function notifyAmpBackInStock(variant) {
    try {
      // Method 1: Update the variant input that the app might be watching
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variant.id) {
        variantInput.value = variant.id;
        // Trigger change event to notify any listeners
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Method 2: Try common AMP Back in Stock methods if they exist
      if (
        window.AMP &&
        window.AMP.BackInStock &&
        typeof window.AMP.BackInStock.selectVariant === "function"
      ) {
        window.AMP.BackInStock.selectVariant(variant.id);
      } else if (
        window.ampBackInStock &&
        typeof window.ampBackInStock.selectVariant === "function"
      ) {
        window.ampBackInStock.selectVariant(variant.id);
      }

      // Method 3: Dispatch custom event that the app might listen for
      window.dispatchEvent(
        new CustomEvent("amp:variant:change", {
          detail: {
            variant: variant,
            productId: variant.product_id || window.meta?.product?.id,
          },
        })
      );

      // Method 4: Update any data attributes that the app might read
      const bisButtons = document.querySelectorAll("[data-bis-trigger]");
      bisButtons.forEach((button) => {
        button.setAttribute("data-variant-id", variant.id);
        button.setAttribute(
          "data-product-id",
          variant.product_id || window.meta?.product?.id || ""
        );
      });
    } catch (error) {
      console.warn("Error notifying AMP Back in Stock app:", error);
    }
  }

  // Check initial state on page load
  document.addEventListener("DOMContentLoaded", function () {
    // Get initial variant data from the variant picker
    const variantPicker = document.querySelector("variant-picker");
    if (variantPicker) {
      const variantScript = variantPicker.querySelector("script[data-variant]");
      if (variantScript) {
        try {
          const variant = JSON.parse(variantScript.textContent || "{}");
          if (variant && variant.id) {
            updateButtonState(variant);
          }
        } catch (e) {
          console.warn("Could not parse initial variant data:", e);
        }
      }
    }
  });
};

ShopifyCustom.setVariantOnLoad = function () {
  function updateVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (!variantId) return;

    const stickyEl = document.getElementById('constructor-product-info');
    if (stickyEl) {
      stickyEl.setAttribute('data-cnstrc-item-variation-id', variantId);
    }
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', updateVariantIdFromUrl);

  // Patch history.pushState and history.replaceState to also trigger update
  ['pushState', 'replaceState'].forEach(method => {
    const original = history[method];
    history[method] = function () {
      original.apply(this, arguments);
      updateVariantIdFromUrl();
    };
  });

  // Handle back/forward nav
  window.addEventListener('popstate', updateVariantIdFromUrl);
};

/* === Feature Modules === */
//Sample Function
// ShopifyCustom.homeHeroAnimation = function () {
//   if (!document.body.classList.contains('template-index')) return;

//   const hero = document.querySelector('.hero-banner');
//   if (hero) {
//     hero.classList.add('fade-in');
//   }
// };


/* === Initialize after DOM is ready === */
document.addEventListener('DOMContentLoaded', () => {
    ShopifyCustom.init();
});
